import { getAccessToken } from "../authToken";

const baseUrl = String(import.meta.env.VITE_API_BASE_URL ?? import.meta.env.VITE_GENESIS_API_URL ?? "").replace(/\/+$/, "");
const isBrowserLocalhost = typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
const isApiUrlLocalhost = /localhost|127\.0\.0\.1/.test(baseUrl);

if (!isBrowserLocalhost && isApiUrlLocalhost) {
  throw new Error("Invalid VITE_GENESIS_API_URL for deployed environment.");
}

export const genesisApiRoot = async (endpoint: string): Promise<RequestInit & { url: string }> => {
  const token = await getAccessToken();
  const url = `${baseUrl}/${endpoint}`;
  return {
    url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const genesisApiRootWithoutContentType = async (endpoint: string): Promise<RequestInit & { url: string }> => {
  const token = await getAccessToken();
  const url = `${baseUrl}/${endpoint}`;
  return {
    url,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const genesisApiRootFile = async (endpoint: string): Promise<RequestInit & { url: string }> => {
  const token = await getAccessToken();
  const url = `${baseUrl}/${endpoint}`;
  return {
    url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
  };
};
